import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import BusinessInfo from '../../../../components/BusinessInfo/BusinessInfo';
import classes from 'classnames';
import LogoutButton from '../../LogoutButton/LogoutButton';
import styles from './MobileFooter.module.scss';

export interface MobileFooterProps {
  onLogout?: () => void;
  hideLogout?: boolean;
}

export const MobileFooter: FC<MobileFooterProps> = (props) => {
  const { onLogout, hideLogout } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.footer}>
      <BusinessInfo
        className={styles['footer-hours']}
        businessHours={t('businessHours').replace(/,\s/g, '<br />')}
        contactMail={t('email')}
        contactPhone={t('phone')}
      />
      <div
        className={classes(
          styles['footer-logout'],
          hideLogout !== true ? styles['logout-btn-show'] : undefined,
        )}
      >
        {(onLogout && (
          <LogoutButton onClick={onLogout}>{t('logout')}</LogoutButton>
        )) || <div />}
        <div className={styles['credit-control']}>
          <img
            src="/images/credit-safe-logo.png"
            alt={t('leftPanel_creditSafeLogoAlt')}
          />
        </div>
      </div>
    </div>
  );
};
